import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function UsaTollFree() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }

            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'UsaTollfree') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    //-----------------------------------------------Fields-------------------------------------------------//

    // Letter of Agency
    const [carrierName, setCarrierName] = useState();
    const [respOrgId, setRespOrgId] = useState();

    // Country checkboxes (multi-select: USA / Canada / Caribbean)
    const [country, setCountry] = useState([]);

    // Company / contact details
    const [companyName, setCompanyName] = useState();
    const [printContact, setPrintContact] = useState();
    const [address, setAddress] = useState();
    const [city, setCity] = useState();
    const [state, setState] = useState();
    const [zip, setZip] = useState();

    // Sign-off
    const [signature, setSignature] = useState();
    const [date, setDate] = useState();
    const [printName, setPrintName] = useState();

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#carrierName').value = form?.country?.loa?.carrierName ?? '';
        document.querySelector('#respOrgId').value = form?.country?.loa?.respOrgId ?? '';
        setCarrierName(form?.country?.loa?.carrierName ?? '');
        setRespOrgId(form?.country?.loa?.respOrgId ?? '');

        setCountry(form?.country?.loa?.country ?? []);

        document.querySelector('#companyName').value = form?.country?.customer?.companyName ?? '';
        document.querySelector('#printContact').value = form?.country?.customer?.printContact ?? '';
        document.querySelector('#address').value = form?.country?.customer?.address ?? '';
        document.querySelector('#city').value = form?.country?.customer?.city ?? '';
        document.querySelector('#state').value = form?.country?.customer?.state ?? '';
        document.querySelector('#zip').value = form?.country?.customer?.zip ?? '';
        setCompanyName(form?.country?.customer?.companyName ?? '');
        setPrintContact(form?.country?.customer?.printContact ?? '');
        setAddress(form?.country?.customer?.address ?? '');
        setCity(form?.country?.customer?.city ?? '');
        setState(form?.country?.customer?.state ?? '');
        setZip(form?.country?.customer?.zip ?? '');

        setTableData(form?.country?.range ?? []);

        document.querySelector('#signature').value = form?.country?.requestor?.signature ?? '';
        document.querySelector('#date').value = form?.country?.requestor?.date ?? '';
        document.querySelector('#printName').value = form?.country?.requestor?.printName ?? '';
        setSignature(form?.country?.requestor?.signature ?? '');
        setDate(form?.country?.requestor?.date ?? '');
        setPrintName(form?.country?.requestor?.printName ?? '');
    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null);

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Number Range)--------------------------------------//

    const [tableData, setTableData] = useState([
        { id: Date.now(), rangeStart: '', rangeStop: '' }
    ]);

    const addRow = () => {
        setTableData([
            ...tableData,
            { id: Date.now(), rangeStart: '', rangeStop: '' }
        ]);
    };

    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });

        setTableData(updatedData);
    };

    //--------------------------------Upload / Download template--------------------------------------//

    const fileInputRef = React.createRef();
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                range: 4
            });

            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];

            const expectedHeaders = [
                'Public from',
                'Public to',
                'Private from',
                'Private to',
                'Local Country Value'
            ];

            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            const dataRows = jsonData.slice(1);

            const formattedRows = dataRows.map((row, index) => {
                const first = row[0]?.toString() || '';
                const last = row[1]?.toString() || '';

                return {
                    id: index + 1,
                    rangeStart: first,
                    rangeStop: last
                };
            });

            setTableData(formattedRows);

            const updatedValidation = {};

            formattedRows.forEach(row => {
                const startValid = /^\d{11}$/.test(row.rangeStart);
                const endValid =
                    /^\d{11}$/.test(row.rangeStop) &&
                    parseInt(row.rangeStop, 10) >= parseInt(row.rangeStart, 10);

                updatedValidation[`start-${row.id}`] = startValid;
                updatedValidation[`end-${row.id}`] = endValid;
            });

            setValidationStates(updatedValidation);
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';

        setTableData([
            { id: Date.now(), rangeStart: '', rangeStop: '' }
        ]);
    };

    const handleDownload = async () => {
        try {
            const response = await fetch(
                `/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`
            );

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx";

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    //-----------------------------------------------Country checkbox-------------------------------------------------//

    const handleCountryChange = (e) => {
        const value = e.target.value;

        if (country.includes(value)) {
            setCountry(country.filter((c) => c !== value));
        } else {
            setCountry([...country, value]);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "UsaTollfree",

            "loa": {
                "carrierName": carrierName,
                "respOrgId": respOrgId,
                "country": country
            },

            "customer": {
                "companyName": companyName,
                "printContact": printContact,
                "address": address,
                "city": city,
                "state": state,
                "zip": zip
            },

            "range": tableData,

            "requestor": {
                "signature": signature,
                "date": date,
                "printName": printName
            }
        },

        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!carrierName) {
            validationErrors.carrierName = 'please fill in Carrier Name';
        }

        if (country.length === 0) {
            validationErrors.country = 'please select at least one Country';
        }

        if (!companyName) {
            validationErrors.companyName = 'please fill in Company Name';
        }

        if (!printContact) {
            validationErrors.printContact = 'please fill in Print Contact';
        }

        if (!address) {
            validationErrors.address = 'please fill in Address';
        }

        if (!city) {
            validationErrors.city = 'please fill in City';
        }

        if (!state) {
            validationErrors.state = 'please fill in State';
        }

        if (!zip) {
            validationErrors.zip = 'please fill in Zip';
        }

        tableData.forEach((row, index) => {

            if (!row.rangeStart) {
                validationErrors[`start-${row.id}`] =
                    `please fill in Start Range for row ${index + 1}`;
            }

            if (!row.rangeStop) {
                validationErrors[`end-${row.id}`] =
                    `please fill in End Range for row ${index + 1}`;
            }
        });

        if (!signature) {
            validationErrors.signature = 'please fill in Signature';
        }

        if (!date) {
            validationErrors.date = 'please fill in Date';
        }

        if (!printName) {
            validationErrors.printName = 'please fill in Print Name';
        }

        const hasValidationError =
            Object.values(validationErrors).length > 0;

        if (hasValidationError) {

            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];

            const el = document.getElementById(firstErrorKey);

            if (el) {
                el.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center"
                });
            }

            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {

            toast.error(
                `Please make sure fields in red are correct. \n${falseKeys} `
            );

            const elem = document.getElementById(falseKeys[0]);

            if (elem) {
                elem.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center"
                });
            }

            return;
        }

        e.preventDefault();

        try {

            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/generate_loa`,
                {
                    method: 'POST',

                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: jsonString
                }
            );

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);

            const a = document.createElement('a');
            a.href = url;
            a.download = carrierName + '-LOA.docx';

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(url);

        } catch (error) {

            console.error('Error downloading file: ', error);

            window.location.href =
                'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {

        const dataToBeDeleted = {
            "email": userEmail
        };

        dispatch(deleteForm(dataToBeDeleted));

        localStorage.removeItem('form');

        window.location.reload();
    }

    async function save(e) {

        e.preventDefault();

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);

                return value === false &&
                    element &&
                    element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {

            const elem = document.getElementById(falseKeys[0]);

            if (elem) {
                elem.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center"
                });
            }

            toast.error(
                `Please make sure following fields in red are correct before saving `
            );

            return;
        }

        localStorage.setItem('form', JSON.stringify(json));

        const dataToBeSaved = {
            "email": userEmail,
            "json_data": json
        };

        try {

            const response = await dispatch(
                saveForm(dataToBeSaved)
            );

            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }

        } catch (error) {

            toast.error(
                'There was an error processing your request.'
            );
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster
                position="top-center"
                reverseOrder={false}
            />

            <div className='french'>

                <Container>

                    <p>
                        <strong>
                            Mandatory fields are marked by *
                        </strong>
                    </p>

                    <br></br>

                    <h2 className='heading'>
                        Letter of Agency
                    </h2>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('carrierName')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Carrier Name*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setCarrierName(e.target.value)
                                }
                                type="text"
                                id="carrierName"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.carrierName === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'carrierName',
                                        /^[a-zA-Z0-9\s\W]+$/
                                    )
                                }
                            />

                            {hoveredField === 'carrierName' && (
                                <div className="hover-description">
                                    Enter Carrier Name
                                </div>
                            )}

                        </Col>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('respOrgId')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Resp Org ID
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setRespOrgId(e.target.value)
                                }
                                type="text"
                                id="respOrgId"
                                placeholder=""
                                className='inputbox'
                            />

                            {hoveredField === 'respOrgId' && (
                                <div className="hover-description">
                                    Optional Resp Org ID
                                </div>
                            )}

                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('country')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Country* (choose one or more)
                            </label>

                            <br />

                            <div id="country">

                                <label
                                    style={{
                                        marginRight: '15px'
                                    }}
                                >

                                    <input
                                        type="checkbox"
                                        value="USA"
                                        checked={country.includes('USA')}
                                        onChange={handleCountryChange}
                                    />

                                    {' '}USA

                                </label>

                                <label
                                    style={{
                                        marginRight: '15px'
                                    }}
                                >

                                    <input
                                        type="checkbox"
                                        value="Canada"
                                        checked={country.includes('Canada')}
                                        onChange={handleCountryChange}
                                    />

                                    {' '}Canada

                                </label>

                                <label>

                                    <input
                                        type="checkbox"
                                        value="Caribbean"
                                        checked={country.includes('Caribbean')}
                                        onChange={handleCountryChange}
                                    />

                                    {' '}Caribbean

                                </label>

                            </div>

                            {hoveredField === 'country' && (
                                <div className="hover-description">
                                    Choose one or more country
                                </div>
                            )}

                        </Col>

                    </Row>

                </Container>

                <br></br>
                <br></br>

                <Container>

                    <h2 className='heading'>
                        Number Range
                    </h2>

                    <br></br>

                    <Row>

                        <Col>

                            <button
                                className="inputbox"
                                onClick={handleDownload}
                                style={{
                                    alignItems: 'center'
                                }}
                            >

                                <FontAwesomeIcon
                                    icon={faDownload}
                                    style={{
                                        marginRight: '8px'
                                    }}
                                />

                                Download number range template

                            </button>

                        </Col>

                        <Col>

                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{
                                    alignItems: 'center'
                                }}
                                onClick={() =>
                                    fileInputRef.current.click()
                                }
                            >

                                <FontAwesomeIcon
                                    icon={faUpload}
                                    style={{
                                        marginRight: '8px'
                                    }}
                                />

                                Upload File

                            </button>

                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{
                                    display: 'none'
                                }}
                            />

                        </Col>

                        <Col>

                            {uploadedFileName && (

                                <button
                                    onClick={removeUploadedFile}
                                    className="inputbox"
                                    style={{
                                        alignItems: 'center'
                                    }}
                                >

                                    <FontAwesomeIcon
                                        icon={faTrash}
                                        style={{
                                            marginRight: '8px'
                                        }}
                                    />

                                    Remove

                                </button>

                            )}

                        </Col>

                    </Row>

                    <Row>

                        <Col>

                            {uploadedFileName && (

                                <div
                                    style={{
                                        display: 'flex',
                                         alignItems: 'center',
                                        marginTop: '10px'
                                    }}
                                >

                                    <p
                                        style={{
                                            marginRight: '10px'
                                        }}
                                    >
                                        Uploaded File: {uploadedFileName}
                                    </p>

                                </div>

                            )}

                        </Col>

                    </Row>

                    <br />

                    <p>
                        The template is the same used for the btd portability request.
                    </p>

                    <br />

                    <Table bordered>

                        <thead>

                            <tr>

                                <th>
                                    First number in range*
                                </th>

                                <th>
                                    Last number in range*
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {tableData.map((row) => (

                                <tr key={row.id}>

                                    <td>

                                        <input
                                            type="text"
                                            id={`start-${row.id}`}
                                            value={row.rangeStart}
                                            onChange={(e) => {

                                                const value =
                                                    e.target.value;

                                                handleChange_table(
                                                    row.id,
                                                    'rangeStart',
                                                    value
                                                );

                                                setValidationStates(
                                                    prev => ({
                                                        ...prev,

                                                        [`start-${row.id}`]:
                                                            /^\d{11}$/.test(value)
                                                    })
                                                );

                                            }}
                                            className={`inputbox ${
                                                validationStates[
                                                    `start-${row.id}`
                                                ] === false
                                                    ? 'error'
                                                    : ''
                                            }`}
                                            onBlur={() => {

                                                if (
                                                    !/^\d{11}$/.test(
                                                        row.rangeStart
                                                    )
                                                ) {

                                                    toast.error(
                                                        'Start Range must be exactly 11 digits.'
                                                    );

                                                }

                                            }}
                                        />

                                    </td>

                                    <td>

                                        <input
                                            type="text"
                                            id={`end-${row.id}`}
                                            value={row.rangeStop}
                                            onChange={(e) => {

                                                const value =
                                                    e.target.value;

                                                handleChange_table(
                                                    row.id,
                                                    'rangeStop',
                                                    value
                                                );

                                                setValidationStates(
                                                    prev => ({
                                                        ...prev,

                                                        [`end-${row.id}`]:
                                                            /^\d{11}$/.test(value)
                                                    })
                                                );

                                            }}
                                            className={`inputbox ${
                                                validationStates[
                                                    `end-${row.id}`
                                                ] === false
                                                    ? 'error'
                                                    : ''
                                            }`} 
                                            onBlur={() => {

                                                if (
                                                    !/^\d{11}$/.test(
                                                        row.rangeStop
                                                    )
                                                ) {

                                                    toast.error(
                                                        'End Range must be exactly 11 digits.'
                                                    );

                                                } else if (
                                                    parseInt(
                                                        row.rangeStop,
                                                        10
                                                    ) <
                                                    parseInt(
                                                        row.rangeStart,
                                                        10
                                                    )
                                                ) {

                                                    toast.error(
                                                        'End range must be greater than or equal to start range'
                                                    );

                                                }

                                            }}
                                        />

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </Table>

                    <button onClick={addRow}>
                        Add Row
                    </button>

                </Container>

                <br></br>
                <br></br>

                <Container>

                    <h2 className='heading'>
                        Customer Details
                    </h2>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('companyName')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Company Name*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setCompanyName(e.target.value)
                                }
                                type="text"
                                id="companyName"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.companyName === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'companyName',
                                        /^[a-zA-Z0-9\s\W]+$/
                                    )
                                }
                            />

                            {hoveredField === 'companyName' && (
                                <div className="hover-description">
                                    Enter Company Name
                                </div>
                            )}

                        </Col>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('printContact')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Print Contact*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setPrintContact(e.target.value)
                                }
                                type="text"
                                id="printContact"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.printContact === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'printContact',
                                        /^[a-zA-Z0-9\s\W]+$/
                                    )
                                }
                            />

                            {hoveredField === 'printContact' && (
                                <div className="hover-description">
                                    Enter Print Contact
                                </div>
                            )}

                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('address')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Address*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setAddress(e.target.value)
                                }
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.address === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'address',
                                        /^[a-zA-Z0-9\s\W]+$/
                                    )
                                }
                            />

                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    Enter Address
                                </div>
                            )}

                        </Col>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('city')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                City*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setCity(e.target.value)
                                }
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.city === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'city',
                                        /^[a-zA-Z\s]+$/
                                    )
                                }
                            />

                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Enter City
                                </div>
                            )}

                        </Col>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('state')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                State*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setState(e.target.value)
                                }
                                type="text"
                                id="state"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.state === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'state',
                                        /^[a-zA-Z\s]+$/
                                    )
                                }
                            />

                            {hoveredField === 'state' && (
                                <div className="hover-description">
                                    Enter State
                                </div>
                            )}

                        </Col>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('zip')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Zip*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setZip(e.target.value)
                                }
                                type="text"
                                id="zip"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.zip === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'zip',
                                        /^\d{5}(-\d{4})?$/
                                    )
                                }
                            />

                            {hoveredField === 'zip' && (
                                <div className="hover-description">
                                    Enter Zip
                                </div>
                            )}

                        </Col>

                    </Row>

                </Container>

                <br></br>
                <br></br>

                <Container>

                    <h2 className='heading'>
                        Sign Off
                    </h2>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('signature')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Signature*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setSignature(e.target.value)
                                }
                                type="text"
                                id="signature"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.signature === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'signature',
                                        /^[\w\W,]+$/
                                    )
                                }
                            />

                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Enter Signature
                                </div>
                            )}

                        </Col>

                        <Col>

                            <label>
                                Date*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setDate(e.target.value)
                                }
                                type="date"
                                id="date"
                                value={date}
                                className={`inputbox ${
                                    validationStates.date === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() => {
                                    validateInput(
                                        'date',
                                        /^.*$/
                                    );
                                }}
                                min={
                                    new Date(
                                        new Date().setDate(
                                            new Date().getDate() + 1
                                        )
                                    )
                                        .toISOString()
                                        .split('T')[0]
                                }
                            />

                        </Col>

                        <Col
                            onMouseEnter={() =>
                                handleMouseEnter('printName')
                            }
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>
                                Print Name*
                            </label>

                            <br />

                            <input
                                onChange={(e) =>
                                    setPrintName(e.target.value)
                                }
                                type="text"
                                id="printName"
                                placeholder=""
                                className={`inputbox ${
                                    validationStates.printName === false
                                        ? 'error'
                                        : ''
                                }`}
                                onBlur={() =>
                                    validateInput(
                                        'printName',
                                        /^[a-zA-Z0-9\s\W]+$/
                                    )
                                }
                            />

                            {hoveredField === 'printName' && (
                                <div className="hover-description">
                                    Enter Print Name
                                </div>
                            )}

                        </Col>

                    </Row>

                </Container>

                <br></br>
                <br></br>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >

                    <Button
                        variant="primary"
                        type="save"
                        onClick={save}
                    >
                        Save
                    </Button>

                    <Button
                        variant="primary"
                        type="submit"
                        onClick={Submit}
                    >
                        Generate LOA
                    </Button>

                    <Button
                        variant="primary"
                        type="reset"
                        onClick={Reset}
                        style={{
                            marginRight: '20px'
                        }}
                    >
                        Reset
                    </Button>

                </div>

            </div>

        </div>
    );
}

export default UsaTollFree;